import { createGlobalStyle } from "styled-components";

const SidebarStyle = createGlobalStyle`
    .sidebar-open{
        width: 17%;
    }
    .sidebar-close{
        width: 7%;
    }   
    .sidebar{
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.12);
        height: 100vh;
        .hamburger{
            width: 32px;
            height: 32px;
        }
         .logo{
            width: 102px;
            height: 38px;
        }
        .sidebar-list{
                height: calc(100vh - 153px);
                overflow: auto;
                scrollbar-width: none;
                ::-webkit-scrollbar {
                  display: none;
                }
            .sidebar-list-item:first-of-type{
                margin: 0
            }
            .sidebar-list-item{
                margin: 5px 0;
                padding: 10px 0;
                transition: all 0.25s linear 0s;
                img{
                    width: 24px;
                    height: 24px;
                }
                span{
                    color: #fff;
                    transition: all 0.25s linear 0s;
                }
            }
            .sidebar-active{
                   background: #000;
                   transition: all 0.25s linear 0s;
                  span{
                        color: #BDFF00;
                        transition: all 0.25s linear 0s;
                   }
                   img{
                         filter: invert(76%) sepia(98%) saturate(872%) hue-rotate(75deg) brightness(659%) contrast(109%);
                         transition: all 0.25s linear 0s;
                   }
            }
        }  
        .user-popup{
            width: 196px;
            left: 50%;
            top: -80px;
            margin-left: -97px;
            border-radius: 10px;
            z-index: 99;
        }
        .logout{
            padding: 10px 15px;
            span{
                padding-left: 15px;
            }
        } 
    }
`;

export default SidebarStyle;
